import { paths } from '../../../../../common/constants/pathVariables';
import { omaElisaForCompaniesMsg, supportCasesAndMessagesMsg, t } from '../../../../../common/i18n';
import { MessageCenter } from '../../../../../components/MessageCenter/MessageCenter';
import { SupportCasesAndMessages } from '../../../../../components/MessageCenter/SupportCasesAndMessages';

export const SupportCasesAndMessagesPath = () => {
  return (
    <MessageCenter
      breadCrumbs={[
        { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
        { name: t.NPCK(supportCasesAndMessagesMsg) },
      ]}
    >
      <SupportCasesAndMessages />
    </MessageCenter>
  );
};
